import { showModal, showNestedModal } from "../../features/modal/modalSlice";
import { useScrollLock } from "../../hooks/useScrollLock";
import Button from "../shared/Button";
import Btn from "../shared/button/Btn"
import PageTopTitle from "../shared/PageTopTitle";
import { handleActiveSelect } from "../../features/layout/layoutSlice";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  getUserComments,
  getUserData,
  getUserDocImage,
} from "../../features/user/userSlice";
import RatingContainer from "../../components/shared/RatingContainer";

import ProfileDocsAndImages from "../../components/profile/ProfileDocsAndImages";
import question from "../../images/svg/question.svg";
import * as BsIcons from "react-icons/bs";
import { getTrailAndTruck } from "../../features/admin3/admin3Slice";
import { getAracYetkiBelgesiSorgu } from "../../features/uyelerAraclar/uyelerAraclarSlice";
import placeHolder from "../../images/img/picturePlaceHolder.jpg";

import moment from "moment";
import { useLocation } from "react-router-dom";
const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 1500px;
    max-height: 700px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    /* padding: 20px 50px; */
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    @media (max-width: 1550px) {
      width: 90%;
      max-height: 90vh;
    }

    .content {
      /* padding: 40px 0; */
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      .btn{
        margin-bottom: 20px;
        position: sticky;
        bottom: 0;
        height: 70px;
        background-color: white;
        width: 100%;
        border-top: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99;
      }
      .top-side {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 10px 40px;
        .profile {
          width: 30%;
          height: 100%;
          display: flex;
          align-items: center;
          img {
            width: 110px;
            height: 110px;
            border-radius: 10px;
          }
          .name-info {
            margin-left: 15px;
            .user-average {
              background-color: var(--color-main);
              display: inline-block;
              border-radius: 5px;
              padding: 5px 10px;
              font-size: 12px;
              font-weight: 600;
              line-height: 14px;
              color: white;
              .star-icon {
                color: white;
                width: 12px;
                margin-right: 5px;
              }
            }
            .name {
              margin-block: 10px;
              font-size: 18px;
              font-weight: 500;
              color: var(--color-dark);
              line-height: 21px;
            }
            .phone {
              font-size: 18px;
              font-weight: 500;
              line-height: 21px;
              color: var(--color-dark);
            }
          }
        }
        .info {
          width: 70%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          height: 100%;
          ul {
            list-style-type: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 20px;
            border: 1px solid var(--color-light);
            li {
              display: flex;
              flex-direction: column;
              text-align: center;
              p {
                font-size: 14px;
                font-weight: 500;
                line-height: 16px;
                margin-bottom: 10px;
              }
              span {
                font-size: 14px;
                font-weight: 400;
                line-height: 16px;
              }
            }
          }
        }
      }

      .bottom-side {
        width: 100%;
        padding-bottom: 20px;
        display: flex;
        /* align-items: center; */
        justify-content: space-between;
        .bottom-left {
          width: 55%;
          border-right: 1px solid;
          border-color: ${({ theme }) => theme.mainBorderColor};
          /* border-bottom: 1px solid var(--color-light); */
          max-height: 400px;
          .assessment {
            .star-assessment {
              display: grid;
              padding: 20px 20px 20px 40px;
              grid-template-columns: 1fr 1fr;
              gap: 10px;
              border-bottom: 1px solid;
              border-color: ${({ theme }) => theme.mainBorderColor};
              .rating {
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 500;
                line-height: 16px;
                p {
                  margin-right: 10px;
                }
                svg {
                  width: 15px !important;
                  height: 15px !important;
                }
              }
            }
            .filter {
              display: grid;
              grid-template-columns: 1fr;
              gap: 10px;
              border-bottom: 1px solid ;
              border-color: ${({ theme }) => theme.mainBorderColor};
              padding: 20px 20px 20px 40px;
              justify-content: space-between;
              .filter-list {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
                gap: 10px;
                .filter-rate {
                  padding: 5px;
                  display: flex;
                  align-items: center;
                  border: 1px solid ;
                  border-color: ${({ theme }) => theme.mainBorderColor};
                  border-radius: 5px;
                  justify-content: space-around;
                  width: fit-content;
                  p {
                    margin-right: 10px;
                  }
                  svg {
                    width: 15px !important;
                    height: 15px !important;
                  }
                }
              }
            }
            .no-comment{
              padding: 20px 20px 20px 40px;
              font-weight: 500;
              border-bottom: 1px solid;
              border-color: ${({ theme }) => theme.mainBorderColor};
            }
            .comments {
              display: flex;
              flex-direction: column;
              max-height: 310px;
              overflow: auto;
              border-bottom: 1px solid;
              border-color: ${({ theme }) => theme.mainBorderColor};
              ::-webkit-scrollbar {
                width: 10px; /* scrollbar genişliği */
              }

              /* Scrollbar başparmağı (kaydırma kolu) */
              ::-webkit-scrollbar-thumb {
                background-color: var(--color-dark); /* başparmak rengi */
                border-radius: 6px; /* başparmak kenar yarıçapı */
              }

              /* Scrollbar izi (arka plan) */
              ::-webkit-scrollbar-track {
                background-color: var(--color-light); /* iz rengi */
              }
              p {
                font-size: 14px;
                font-weight: 500;
                line-height: 16px;
              }
              .comment-list {
                display: flex;
                flex-direction: column;
                padding: 20px 20px 20px 40px;
                border-bottom: 1px solid ;
                border-color: ${({ theme }) => theme.mainBorderColor};
                .list-item {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 60%;
                  p {
                    margin-right: 15px;
                  }
                  svg {
                    width: 15px !important;
                    height: 15px !important;
                  }
                }
                .date {
                  width: 60%;
                  margin-block: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                }
                .text {
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 22px;
                }
              }
            }
          }
        }
        .bottom-right {
          border: 1px solid;
          border-color: ${({ theme }) => theme.mainBorderColor};
          width: 40%;
          margin-right: 40px;
          .photos {
            padding: 10px 20px;
          }
          .trucks {
            ul {
              list-style-type: none;

              li {
                .truck-list {
                  display: grid;
                  grid-template-columns: 1fr 1fr 1fr;
                  gap: 15px;
                  padding: 10px 20px;
                  border-bottom: 1px solid;
                  border-color: ${({ theme }) => theme.mainBorderColor};
                }
                button {
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  height: 30px !important;
                  line-height: initial !important;
                }
                p {
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 16px;
                }
                .plaka-item-dropdown {
                  padding: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr 1fr 1fr;
                  border: 1px solid;
                  border-color: ${({ theme }) => theme.mainBorderColor};
                  gap: 15px;
                  img {
                    width: 100px;
                    height: 100px;
                  }
                }
              }
            }
          }
          .referances {
            .firmalar {
              padding: 20px;
              display: flex;
              align-items: center;
              p {
                margin-right: 20px;
                font-size: 14px;
                font-weight: 500;
                line-height: 16px;
              }
            }
          }
        }
      }
    }
  }


  @media (max-width: 1350px){
    .bottom-side{
      flex-direction: column;
      gap: 30px;
      .bottom-left{
        width: 100% !important;
      }
      .bottom-right{
        width: 100% !important;
      }
    }
  }

  @media (max-width: 850px){
    .modal{
      width: 100% !important;
      max-height: 100vh !important;
      height: 100vh !important;
    }
    .filter-list{
      grid-template-columns: repeat(3, 1fr) !important;
    }
  }
  @media (max-width: 500px){
    
    .filter-list{
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
`;

const SurucuProfilModal = () => {

  const location = useLocation();
  const dispatch = useDispatch();
  const { userData, userComments, selectUserData } = useSelector(
    (state) => state.user
  );
  const { trucks } = useSelector((state) => state.admin3);

  const [isRatingHover, setIsRatingHover] = useState(false);
  const [activeItem, setActiveItem] = useState(false);
  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  const handleUserDocImage = (image) => {
    if (image) {
      dispatch(getUserDocImage(`${process.env.REACT_APP_API_IMG_URI}${image}`));
      dispatch(showModal("image"));
    }
  };

  useEffect(() => {
    dispatch(getTrailAndTruck(userData?.phoneNumber));
  }, [userData?.phoneNumber, dispatch]);

  useEffect(() => {
    dispatch(getUserData(selectUserData));
  }, []);

  useEffect(() => {
    dispatch(getUserComments({ userId: userData?.id, page: 1 }));
  }, [userData]);

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
      if (location?.pathname !== modalLocation) {
          dispatch(showModal(null))
      }
  }, [dispatch, location?.pathname, modalLocation])

  if(!userData) {
      return null
  }

  return (
    <ModalContainer onClick={() => dispatch(showNestedModal(null))}>
      <div
        className="modal"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="content">
          <div className="top-side">
            <div className="profile">
              <img
                src={
                  userData?.profilePhoto
                    ? `${process.env.REACT_APP_API_IMG_URI}${userData?.profilePhoto}`
                    : question
                }
                alt={userData?.adSoyadUnvan}
              />
              <div className="name-info">
                <div
                  className="user-average"
                  onMouseEnter={() => setIsRatingHover(true)}
                  onMouseLeave={() => setIsRatingHover(false)}
                >
                  <BsIcons.BsFillStarFill className="star-icon" />{" "}
                  {userData?.communicationandCustomerServiceAvarage?.toFixed(1)}{" "}
                </div>
                <div className="name">{userData?.adSoyadUnvan} - </div>
                <div className="phone">{selectUserData}</div>
              </div>
            </div>
            {/* <div className="info">
              <ul>
                <li>
                  <p>Kamyoon'daki Süresi</p>
                  <span>9 ay</span>
                </li>
                <li>
                  <p>Toplam Sefer</p>
                  <span>36</span>
                </li>
                <li>
                  <p>Toplam Km</p>
                  <span>40.000</span>
                </li>
                <li>
                  <p>Araç Bilgileri</p>
                  <span>Volvo FH 700</span>
                </li>
                <li>
                  <p>Firma Bilgileri</p>
                  <span>Ege Yurt Lojistik</span>
                </li>
              </ul>
            </div> */}
          </div>

          <div className="bottom-side">
            <div className="bottom-left">
              <PageTopTitle title={"Sürücü Değerlendirmeleri"} />
              <div className="assessment">
                <div className="star-assessment">
                  <div className="rating">
                    <p>
                    {((userData?.communicationandCustomerServiceAvarage + userData?.deliveryTimeandReliabilityRateAvarage + userData?.equipmentConditionRateAvarage) / 3 )?.toFixed(1)}
                    </p>
                    <RatingContainer
                      rating={userData?.communicationandCustomerServiceAvarage || 0}
                    />
                  </div>
                  <div>
                    {userData?.communicationandCustomerServiceRateCount}{" "}
                    Değerlendirme
                  </div>
                </div>
                <div className="filter">
                  <p>Puana Göre Filtrele</p>
                  <div className="filter-list">
                    <div className="filter-rate">
                      <RatingContainer rating={5} />{" "}
                      <p>
                        ({userData?.communicationandCustomerServiceRateCount || 0})
                      </p>{" "}
                    </div>
                    <div className="filter-rate">
                      <RatingContainer rating={4} />{" "}
                      <p>
                        ({userData?.communicationandCustomerServiceRateCount || 0})
                      </p>{" "}
                    </div>
                    <div className="filter-rate">
                      <RatingContainer rating={3} />{" "}
                      <p>
                        ({userData?.communicationandCustomerServiceRateCount || 0})
                      </p>{" "}
                    </div>
                    <div className="filter-rate">
                      <RatingContainer rating={2} />{" "}
                      <p>
                        ({userData?.communicationandCustomerServiceRateCount || 0})
                      </p>{" "}
                    </div>
                    <div className="filter-rate">
                      <RatingContainer rating={1} />{" "}
                      <p>
                        ({userData?.communicationandCustomerServiceRateCount || 0})
                      </p>{" "}
                    </div>
                  </div>
                </div>
                {
                  userComments?.length > 0 ?
                    <ul className="comments">
                      {userComments?.map((item) => {
                        return (
                          <li className="comment-list">
                            <div className="list-item">
                              <p>
                                {item?.shipment?.routePoints?.$values[0].city} -{" "}
                                {item?.shipment?.routePoints?.$values[0].town} /{" "}
                                {item?.shipment?.routePoints?.$values[1].city} -{" "}
                                {item?.shipment?.routePoints?.$values[1].town}
                              </p>
                              <RatingContainer
                                rating={item?.communicationandCustomerService || 0}
                              />
                            </div>
                            <div className="date">
                              <p>
                                {moment(
                                  item?.shipment?.routePoints?.$values[0].loadDate
                                ).format("DD/MM/YYYY")}
                              </p>
                              <p>
                                {item.shipment.loadUnit}{" "}
                                {item.shipment.loadQuantity}
                              </p>
                              <p>{item.shipment.truckType}</p>
                            </div>
                            <div className="text">
                              {"Yük Sahibi Yorumu"}: {item.comment}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                    :
                    <div className="no-comment">Henüz yorum yapılmamış.</div>
                }
                
              </div>
            </div>
            <div className="bottom-right">
              <div className="documents">
                <PageTopTitle
                  textAlign={"left"}
                  title={"Belgeler ve Fotoğraflar"}
                />
                <div className="photos">
                  <ProfileDocsAndImages
                    modal
                    userData={userData}
                    src={process.env.REACT_APP_API_IMG_URI}
                  />
                </div>
              </div>
              <div className="trucks">
                <PageTopTitle textAlign={"left"} title={"Araçlar"} />
                <ul>
                  {trucks?.map((item, index) => {
                    return (
                      <li>
                        <div className="truck-list">
                          <p>{item?.plateNumber}</p>
                          <Button
                            background="#444444"
                            width="inline-block"
                            color={"#fff"}
                            text={"Yetki Belgesi"}
                            radius="5px"
                            handleClick={() => {
                              dispatch(
                                getAracYetkiBelgesiSorgu(
                                  item.plateNumber || item.trailerPlate
                                )
                              );
                              dispatch(showModal("aracYetkiBelgesiSorgu"));
                            }}
                          />
                          <Button
                            text={"Detay Görüntüle"}
                            background="#444444"
                            width="inline-block"
                            radius="5px"
                            color={"#fff"}
                            handleClick={() =>
                              setActiveItem(activeItem !== index ? index : null)
                            }
                          />
                        </div>
                        {activeItem === index && (
                          <div className="plaka-item-dropdown">
                            <img
                              src={
                                item?.aracFotoOndenSuruculu
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.aracFotoOndenSuruculu}`
                                  : placeHolder
                              }
                              onClick={() =>
                                handleUserDocImage(item?.aracFotoOndenSuruculu)
                              }
                              alt=""
                            />
                            <img
                              src={
                                item?.photo1
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.photo1}`
                                  : placeHolder
                              }
                              onClick={() => handleUserDocImage(item?.photo1)}
                              alt=""
                            />
                            <img
                              src={
                                item?.photo2
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.photo2}`
                                  : placeHolder
                              }
                              onClick={() => handleUserDocImage(item?.photo2)}
                              alt=""
                            />
                            <img
                              src={
                                item?.photo3
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.photo3}`
                                  : placeHolder
                              }
                              onClick={() => handleUserDocImage(item?.photo3)}
                              alt=""
                            />
                            <img
                              src={
                                item?.sasePhoto
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.sasePhoto}`
                                  : placeHolder
                              }
                              onClick={() =>
                                handleUserDocImage(item?.sasePhoto)
                              }
                              alt=""
                            />
                            <img
                              src={
                                item?.ruhsatPhoto
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.ruhsatPhoto}`
                                  : placeHolder
                              }
                              onClick={() =>
                                handleUserDocImage(item?.ruhsatPhoto)
                              }
                              alt=""
                            />
                            <img
                              src={
                                item?.trafikSigortaPolicePohoto
                                  ? `${process.env.REACT_APP_API_IMG_URI}${item?.trafikSigortaPolicePohoto}`
                                  : placeHolder
                              }
                              onClick={() =>
                                handleUserDocImage(
                                  item?.trafikSigortaPolicePohoto
                                )
                              }
                              alt=""
                            />
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="referances">
                <PageTopTitle textAlign={"left"} title={"Referanslar"} />
                <div className="firmalar">
                </div>
              </div>
            </div>
          </div>
          <div className="btn">
            <Btn handleClick={()=>dispatch(showNestedModal(null))} color="#E85446" padding="10px" width="200px">Kapat</Btn>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default SurucuProfilModal;
